import { toTableCellTextFromName } from '../../Table.utils'

export function toTableBuildingGroupsListCell(data) {
  return {
    ...toTableCellTextFromName(data),
    src: data.avatar,
  }
}
